import React from "react";

/* ─────────────────────────────────────────────────────────────
   MarketingOutcomes · Phase 4 Homepage
   ------------------------------------------------------------
   Deliberately SHORT section. Three operating outcomes only —
   NO fabricated statistics, NO percentages, NO time-saved
   claims, NO customer logos or testimonials.
   ───────────────────────────────────────────────────────────── */

const OUTCOMES = [
  {
    kicker: "Less chasing",
    body: "See what is outstanding and who needs to act — without manually piecing updates together.",
  },
  {
    kicker: "More clarity",
    body: "One view of transaction progress, participants, blockers and next actions.",
  },
  {
    kicker: "Better control",
    body: "Surface priority work and keep progression moving from sale agreed to exchange.",
  },
];

export const MarketingOutcomes = () => (
  <section
    id="outcomes"
    className="relative"
    style={{ background: "#FFFFFF" }}
    data-testid="landing-outcomes"
  >
    <div
      aria-hidden="true"
      className="absolute inset-x-0 top-0 h-px"
      style={{ background: "linear-gradient(90deg, transparent 0%, rgba(15,23,42,0.08) 50%, transparent 100%)" }}
    />
    <div className="max-w-[1200px] mx-auto px-5 sm:px-6 lg:px-10 py-14 lg:py-20">
      <div className="max-w-[760px]">
        <h2 className="font-display text-[28px] sm:text-[36px] lg:text-[44px] font-bold tracking-[-0.028em] text-slate-900 leading-[1.05]">
          Less chasing.<br />
          More clarity.<br />
          <span
            style={{
              background: "linear-gradient(90deg, #4F46E5 0%, #6D28D9 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Better control.
          </span>
        </h2>
      </div>

      <div className="mt-10 lg:mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10">
        {OUTCOMES.map(({ kicker, body }) => (
          <div
            key={kicker}
            className="min-w-0"
            data-testid={`landing-outcomes-${kicker.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <p className="text-[10.5px] font-bold uppercase tracking-[0.22em] text-violet-700">
              {kicker}
            </p>
            <p className="text-[13.5px] lg:text-[14.5px] text-slate-700 leading-relaxed mt-2.5">
              {body}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default MarketingOutcomes;
